import { motion } from "framer-motion";

const railV = {
  hidden: {},
  show: { transition: { staggerChildren: 0.06 } },
};
const itemV = {
  hidden: { opacity: 0, x: -28 },
  show: { opacity: 1, x: 0, transition: { duration: 0.4, ease: "easeOut" } },
};

/** Left rail (desktop) / chip row (mobile) of timeline categories. */
export default function CategoryRail({ categories, active, onSelect }) {
  return (
    <motion.div
      className="rail"
      role="tablist"
      aria-label="Timeline categories"
      variants={railV}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.4 }}
    >
      {categories.map((c) => (
        <motion.button
          key={c.id}
          type="button"
          role="tab"
          aria-selected={active === c.id}
          className={"rail__item" + (active === c.id ? " is-active" : "")}
          onClick={() => onSelect(c.id)}
          variants={itemV}
        >
          {c.label}
        </motion.button>
      ))}
    </motion.div>
  );
}
